import { Stack } from '@mantine/core'
import React, { useState } from 'react'

import { ipfsDomains } from '@/utils/utils'

import placeholderImageOnLoad from '../../assets/webp_converted/imageOnload.webp'
import IpfsImageLoader from './IpfsImageLoader'

export const SimpleImage: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
  src,
  className,
  alt,
  style,
}) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)
  const [tries, setTries] = useState<number>(0)

  return (
    <img
      className={className}
      src={loading || error ? placeholderImageOnLoad : src}
      alt={alt}
      style={style}
      onError={() => {
        if (tries < 3) {
          setTries(tries + 1)
          setLoading(true)
        } else {
          setError(true)
          setLoading(false)
        }
      }}
      onLoad={() => {
        if (tries >= 3) {
          setError(true)
        } else {
          setError(false)
        }
        setLoading(false)
      }}
    />
  )
}

interface ImageWrapperProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fullImage?: boolean
  onClick?: () => void
}

const ImageWrapper: React.FC<ImageWrapperProps> = ({
  fullImage = false,
  src,
  className,
  alt,
  style,
  onClick,
  ...props
}) => {
  // check if the image is an ipfs image
  const isIpfsImage =
    (src && ipfsDomains.some(domain => src.startsWith(domain))) || src?.startsWith('ipfs://')

  return (
    <Stack onClick={onClick} style={{ width: 'fit-content', height: 'fit-content' }}>
      {src && isIpfsImage ? (
        <IpfsImageLoader
          fullImage={fullImage}
          ipfsHash={src.replace('ipfs://', '')}
          className={className}
          alt={alt}
          style={style}
          {...props}
        />
      ) : (
        <SimpleImage src={src} className={className} alt={alt} style={style} {...props} />
      )}
    </Stack>
  )
}

export default ImageWrapper
